import { fullVHExceptHeader } from 'pobble-components/dist/jss-mixins'

export default {
  pending: {
    ...fullVHExceptHeader,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  notFound: {
    ...fullVHExceptHeader,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    '& img': {
      maxWidth: '300px'
    },
    '& p': {
      margin: '0'
    }
  }
}
